import {Button} from '@primer/react'
import type {PropsWithChildren} from 'react'
import {ShortcutsGroupList} from './ShortcutsGroupList'
import {useKeyboardShortcutsQuery} from '../use-keyboard-shortcuts-query'

import styles from './ShortcutsDialogContent.module.css'

const Columns = ({children}: PropsWithChildren) => <div className={styles.ColumnsContainer}>{children}</div>

const Column = ({children}: PropsWithChildren) => <div className={styles.Column}>{children}</div>

/** Suspends while fetching shortcuts. */
export default function ShortcutsDialogContent({contexts, docsUrl}: {contexts?: string; docsUrl: string}) {
  const {data} = useKeyboardShortcutsQuery(contexts)

  return (
    <Columns>
      <Column>
        {data.shortcutGroups.map(group => (
          <ShortcutsGroupList group={group} key={group.service.id} />
        ))}
      </Column>

      <Column>
        <ShortcutsGroupList group={data.siteWideShortcuts} key={data.siteWideShortcuts.service.id} />
        <Button as="a" href={docsUrl} className={styles.FullWidthButton}>
          View all keyboard shortcuts
        </Button>
      </Column>
    </Columns>
  )
}
